import { render, staticRenderFns } from "./ShippingRoute.vue?vue&type=template&id=c7bfb2bc&"
import script from "./ShippingRoute.vue?vue&type=script&lang=js&"
export * from "./ShippingRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports